import React, { useState, useMemo, useEffect } from 'react';
import { Tabs, Toast, ListView } from 'antd-mobile';
import { StickyContainer, Sticky } from 'react-sticky';
import { unionFlag, getSessonStorage, checkUnifyShop } from '@/utils';
import { router } from 'umi';
import { connect } from 'dva';
import NavBar from '@/components/NavBar';
import DfModal from '@/components/Modal';
import OrderItem from '@/components/OrderItem';
import Api from '@/common/api';
import { orderListQuery, detailQuery } from '@/interface/req';
import styles from './index.less';
import cancelImg from '@/assets/imgs/icon-cancel.png';
import emptyImg from '@/assets/imgs/emptylist.png';
import { TLang, ReplaceText, CheckCN } from '@/utils/lang';
import { gioClick } from '@/utils/gioApi';

const currentPageName = '订单列表页';
const tabs = [
  { title: TLang('全部', 'home', false, false, null), gioTitle: '全部', sub: 0 },
  { title: TLang('待支付', 'home', false, false, null), gioTitle: '待支付', sub: 1 },
  { title: TLang('已支付', 'home', false, false, null), gioTitle: '已支付', sub: 2 },
  { title: TLang('出票中', 'home', false, false, null), gioTitle: '出票中', sub: 3 },
  { title: TLang('出票成功', 'home', false, false, null), gioTitle: '出票成功', sub: 4 },
  { title: TLang('已取消', 'home', false, false, null), gioTitle: '已取消', sub: 5 }
];
// 根据 java 提供order status
let time;
const getOrderStatusFromTab = (tab: number): number => {
  switch (tab) {
    case 0:
      return -1;
    case 1:
      return 3;
    case 2:
      return 4;
    case 3:
      return 5;
    case 4:
      return 6;
    case 5:
      return 8;
    default:
      return -1;
  }
};
const OrderList = (props) => {
  const ds = new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2
  });
  const union = unionFlag() || getSessonStorage('dffl_union');
  const [height, setHeight] = useState<number>(0);
  const [hasMore, setHasMore] = useState(false);
  const [dataSource, setDataSource] = useState(ds);
  const [orderList, setOrderList] = useState<any>([]);
  const [curPage, setCurPage] = useState(1);
  // console.log('props.orderTab',props.orderTab)
  const [tab, setTab] = useState(props.orderTab);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [tmpOrderItem, setTmpOrderItem] = useState(null);
  useEffect(() => {
    // if(props.orderTab){
    //   console.log('tan-- req',props.orderTab,tab)
    //   setTab(props.orderTab)
    // }
    const navDom: any = document.querySelector('.navBarContainer');

    const scrollBarDom: any = document.querySelector('.am-tabs-tab-bar-wrap');
    setHeight(document.documentElement.clientHeight - navDom.offsetHeight - scrollBarDom.offsetHeight);
  }, []);
  useEffect(() => {
    // tab save in dav
    // console.log('tan req',props.orderTab,tab)
    let time = setTimeout(() => {

      setCurPage(1);
      setDataSource(dataSource.cloneWithRows([]));
      setOrderList([]);

      // get order list .
      const os = getOrderStatusFromTab(tab);
      const q: orderListQuery = {};
      q.pageIndex = 1;
      q.pageSize = 20;
      if (os !== -1) {
        q.status = os;
      }
      Api.getOrderList(q).then((res) => {
        if (!res) {
          return;
        }

        setHasMore(res.hasNext);
        const data = [...res.searches];
        setOrderList(data);
        setDataSource(dataSource.cloneWithRows(data));
      });
    }, 300);
    return () => {
      time && clearTimeout(time);
    };
  }, [tab]);

  // gio status name
  const getGioStatusName = (s: number, vendorRefundStatus: number) => {
    if (vendorRefundStatus) {
      switch (vendorRefundStatus) {
        case 5:
          return '退票中';
        case 6:
          return '退票成功';
        case 7:
          return '退票失败';
      }
    }
    switch (s) {
      case 3:
      case 15:
        return '待支付';
      case 4:
        return '已支付';
      case 5:
        return '出票中';
      case 6:
        return '出票成功';
      case 7:
        return '已取消';
      case 11: // 出票失败，系统取消
        return '已取消';
      case 8:
        return '已取消';
      case 9:
        return '申请退款';
      case 10:
        return '退款成功';
      case 14:
        return '已取消';
      case 12:
        return '退款失败';
      case 13:  //供应商退款中
        return '退款中';
    }
  };

  const loadMoreData = () => {
    if (hasMore === false) {
      return;
    }
    const q: orderListQuery = {};
    q.pageIndex = curPage + 1;
    const os = getOrderStatusFromTab(tab);
    q.pageSize = 20;
    if (os !== -1) {
      q.status = os;
    }
    Api.getOrderList(q).then((res) => {
      setHasMore(res.hasNext);
      const data = [...orderList, ...res.searches];
      setOrderList(data);
      setDataSource(dataSource.cloneWithRows(data));
      setCurPage(curPage + 1);
    });
  };
  const payOrderHandle = (item) => {
    let curStatus = tabs.filter((item) => item.sub === tab);
    gioClick('订单详情', {
      pagename: currentPageName,
      modulename: '订单操作',
      elementname: '立即支付',
      status: getGioStatusName(item.status, item.vendorRefundStatus),
      orderNum: item.orderSn
    });
    // console.log('支付, 跳url')
    if (item.paymentUrl) {
      window.df_sdk_common.location.href = item.paymentUrl.indexOf('http') === 0 ? item.paymentUrl : '//' + item.paymentUrl;
    }
  };
  const cancelOrderHandle = (item, timeout: boolean = false) => {
    let curStatus = tabs.filter((item) => item.sub === tab);
    gioClick('订单详情', {
      pagename: currentPageName,
      modulename: '订单操作',
      elementname: '取消订单',
      status: getGioStatusName(item.status, item.vendorRefundStatus),
      orderNum: item.orderSn
    });
    if (timeout === true) {
      // 超时
      // const newOrderList = orderList.map(orderItem=>{
      //   if(orderItem.orderSn === item.orderSn){
      //     orderItem.status=11
      //   }
      //   return orderItem
      // })
      // console.log('----',newOrderList)
      // setOrderList(newOrderList)
      // setDataSource(dataSource.cloneWithRows(newOrderList))
    } else {
      // console.log('取消订单')
      setShowCancelModal(true);
      setTmpOrderItem(item); // 将要取消的订单暂存起来
    }

  };
  const toCancelOrderHandle = () => {
    let curStatus = tabs.filter((item) => item.sub === tab);
    gioClick('订单详情', {
      pagename: currentPageName,
      modulename: '订单操作',
      elementname: '确定取消',
      status: getGioStatusName(tmpOrderItem?.status, tmpOrderItem?.vendorRefundStatus),
      orderNum: tmpOrderItem?.orderSn
    });
    // 发起订单取消请求
    setShowCancelModal(false);
    if (!tmpOrderItem) {
      return Toast.info(TLang('订单取消出现错误', 'home', false, false, null));
    }
    Api.getOrderCancel(tmpOrderItem?.orderSn).then((res) => {
      if (res) {
        Toast.info(TLang('取消订单成功', 'home', false, false, null));
        setTimeout(() => {
          window.location.reload();
        }, 2500);
      }
    });
  };
  const toOrderDesc = (item) => {
    let curStatus = tabs.filter((item) => item.sub === tab);
    gioClick('订单详情', {
      pagename: currentPageName,
      modulename: '订单列表',
      elementname: '订单详情',
      status: getGioStatusName(item.status, item.vendorRefundStatus),
      orderNum: item.orderSn
    });
    props.dispatch && props.dispatch({
      type: 'order/setTab',
      payload: tab
    });
    const origin = window.location.origin;
    window.df_sdk_common.location.href = origin + `/newmovie/order/status?orderSn=${item.orderSn}`;
    // router.push({
    //   pathname: '/order/status',
    //   query: {
    //     orderSn: item.orderSn
    //   }
    // });
  };
  const gotoHome = () => {
    let curStatus = tabs.filter((item) => item.sub === tab);
    gioClick('订单详情', {
      pagename: currentPageName,
      modulename: '空订单',
      elementname: '去逛逛',
      status: curStatus[0].gioTitle
    });
    setTimeout(() => {
      router.push('/?reloadType=reload');
    }, 100);
  };
  const renderTabBar = (props) => (<Sticky>
    {({ style }) => <div style={{ ...style, zIndex: 1 }}><Tabs.DefaultTabBar
      page={CheckCN() ? 5 : 4} {...props}
                                                         /></div>}
  </Sticky>);
  const renderRow = (rowData, sectionID, rowID) => <OrderItem data={rowData}
    click={toOrderDesc}
    cancelOrder={cancelOrderHandle}
    payOrder={payOrderHandle}
                                                   />;
  const emptyView = () => (
    <div className={styles.emptyContainer}>
      <img src={emptyImg} alt="empty" />
      <div className={styles.emptyNotice} style={{ textAlign: 'center' }}>
        {TLang('您还没有订单哦~赶紧去购物吧！', 'home', false, false, null)}
        {/* <p>您还没有订单哦~</p>
        <p>赶紧去购物吧！</p> */}
      </div>
      <div className={styles.emptyBtn} onClick={gotoHome}> {TLang('去逛逛', 'home', false, false, null)}</div>
    </div>
  );
  const renderContent = (tab) => <div className={styles.contentWrapper}>
    {
      orderList.length ? <ListView
        prefixCls="dforder"
        dataSource={dataSource}
        className="dflv"
        renderRow={renderRow}
        pageSize={20}
        onEndReachedThreshold={20}
        onEndReached={loadMoreData}
        scrollEventThrottle={200}
        useBodyScroll={false}
        renderFooter={() => (hasMore ? <div className={styles.listFooter}>...Loading</div> : <div className={styles.listFooter}>- {TLang('已经到底啦', 'home', false, false, null)} -</div>)}
        style={{
          height: height,
          overflow: 'auto'
        }}
                         /> : emptyView()
    }
  </div>;
  return (
    <div className={`${styles.orderListContainer} orderListContainer`}>
      <NavBar isShowMenu showService={false} text={TLang('电影订单', 'home', false, false, null)} initColor="#333" targetColor="#333" targetBgColor="#FFF" opacity={1}
        backAction={() => {
          // TODO: 百福得 H5，点则跳转到百福得商城的个人中心
          gioClick('返回', {
            pagename: currentPageName
          });
          if (union||checkUnifyShop()) {
            window.df_sdk_common.location.href = props.userCenter || '';
          } else {
            window.history.go(-1);
          }
        }}
      />
      <div className={styles.listContainer}>
        <StickyContainer>
          <Tabs tabs={tabs}
            initialPage={tab}
            tabBarActiveTextColor={window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF'}
            tabBarInactiveTextColor="#333333"
            onChange={(item) => {
              gioClick('订单状态Tab', {
                pagename: currentPageName,
                modulename: '订单状态Tab',
                elementname: item.gioTitle
              });
              setTab(item.sub);
            }}
            renderTabBar={renderTabBar}
            prerenderingSiblingsNumber={0}
          >
            {renderContent}

          </Tabs>
        </StickyContainer>
      </div>
      <DfModal show={showCancelModal}
        img={cancelImg}
        desc={TLang('您确认要取消该订单吗', 'home', false, false, null) + '？'}
        left={{
          text: TLang('暂不取消', 'home', false, false, null), action: () => {
            let curStatus = tabs.filter((item) => item.sub === tab);
            gioClick('订单详情', {
              pagename: currentPageName,
              modulename: '订单操作',
              elementname: '暂不取消',
              status: getGioStatusName(tmpOrderItem?.status, tmpOrderItem?.vendorRefundStatus),
              orderNum: tmpOrderItem?.orderSn
            });
            setShowCancelModal(false);
          }
        }}
        right={{ text: TLang('确定取消', 'home', false, false, null), action: toCancelOrderHandle }}
      />
    </div>
  );
};
const mapStateToProps = ({ order }) => ({ orderTab: order.tab, userCenter: order.userCenter });
export default connect(mapStateToProps)(OrderList);





